// janado's own cookie banner (snippets/consent-banner.liquid) on top of Shopify's Customer Privacy API.
// Shopify stores the decision (and applies it to pixels and checkout); this script stores nothing of its own.
// Shown only when Shopify says a banner is needed here and the visitor hasn't decided yet; "Cookie-Einstellungen"
// in the footer ([data-consent-open]) reopens the choices. Each banner impression and each decision is counted
// anonymously at our ingest (POST /c): no ids, no cookies, only the choice, the page type, the device class, the language.
// An impression counts only once a real visitor signal exists (first pointer/touch/scroll/key, or the page visible for 3 s) and
// never under automation (navigator.webdriver), so bots that load the page don't inflate it. Decisions are always counted.
// With the theme setting consent_google_mode the decision also goes to Google Consent Mode (gtag 'consent' 'update').

// own scope: classic scripts share the global scope (a second top-level `const dlg` breaks Safari)
;(() => {
const ENDPOINT = 'https://analytics-ingest-843473162096.europe-west3.run.app/c'
const KEYS = ['analytics', 'marketing', 'preferences']
const dlg = document.getElementById('Consent')

window.dataLayer = window.dataLayer || []
function gtag() { window.dataLayer.push(arguments) } // gtag needs the arguments object, not an array

if (dlg) {
  const prefs = dlg.querySelector('[data-consent-prefs]')
  const box = (k) => prefs.querySelector(`input[name=${k}]`)
  let api = null
  let opener = null // footer button that opened the settings, gets the focus back
  let decidedNow = false
  let fromList = false // decided with "Auswahl speichern" (the switches) rather than one of the two buttons

  const device = () => (matchMedia('(pointer: coarse)').matches ? (Math.min(screen.width, screen.height) >= 600 ? 'tablet' : 'mobile') : 'desktop')
  const count = (body) => {
    try {
      navigator.sendBeacon(ENDPOINT, JSON.stringify({ ...body, page_type: dlg.dataset.pageType || null, device: device(), lang: document.documentElement.lang || null }))
    } catch (e) {}
  }
  const countShown = () => {
    if (navigator.webdriver) return
    const EVENTS = ['pointerdown', 'touchstart', 'scroll', 'keydown']
    let done = false, timer = 0
    const fire = () => {
      if (done) return
      done = true
      clearTimeout(timer)
      EVENTS.forEach((n) => removeEventListener(n, fire, true))
      document.removeEventListener('visibilitychange', arm)
      count({ kind: 'shown', surface: 'banner' })
    }
    // 3 s of continuous visibility; hiding the tab restarts the wait
    function arm() { clearTimeout(timer); if (document.visibilityState === 'visible') timer = setTimeout(fire, 3000) }
    EVENTS.forEach((n) => addEventListener(n, fire, { capture: true, passive: true }))
    document.addEventListener('visibilitychange', arm)
    arm()
  }
  const raw = () => api.currentVisitorConsent() || {} // values 'yes' | 'no' | '' (undecided)
  const decided = () => KEYS.some((k) => (raw()[k] || '') !== '')
  const current = () => Object.fromEntries(KEYS.map((k) => [k, raw()[k] === 'yes']))

  const toGoogle = (c) => {
    if (dlg.dataset.google !== 'true') return
    const g = (v) => (v ? 'granted' : 'denied')
    gtag('consent', 'update', {
      analytics_storage: g(c.analytics),
      ad_storage: g(c.marketing),
      ad_user_data: g(c.marketing),
      ad_personalization: g(c.marketing),
      personalization_storage: g(c.preferences),
    })
  }

  // categories are always visible: switches start off in the banner and show the stored choice in the settings
  let touched = false
  prefs.addEventListener('change', () => { touched = true })
  const showPrefs = (fromFooter) => {
    touched = false
    const c = fromFooter ? current() : { analytics: false, marketing: false, preferences: false }
    KEYS.forEach((k) => (box(k).checked = c[k]))
    if (fromFooter) box(KEYS[0]).focus()
  }

  const decide = (c) => {
    const surface = opener ? 'settings' : touched || fromList ? 'settings' : 'banner'
    const decision = KEYS.every((k) => c[k]) ? 'accept_all' : KEYS.every((k) => !c[k]) ? 'decline_all' : 'custom'
    decidedNow = true
    // sale_of_data is only asked in US states with such laws (saleOfDataRegion); Shopify keeps its default here
    api.setTrackingConsent(c, (r) => { if (r && r.error) console.warn('consent not saved', r.error) })
    count({ kind: 'decision', decision, ...c, surface })
    toGoogle(c)
    dlg.close()
  }

  dlg.addEventListener('click', (e) => {
    const b = e.target.closest('[data-consent]')
    if (!b) return
    const v = b.dataset.consent
    fromList = v === 'save'
    decide(Object.fromEntries(KEYS.map((k) => [k, v === 'accept' ? true : v === 'decline' ? false : box(k).checked])))
  })

  // Escape: the first banner needs a decision and stays; the settings opened from the footer close normally
  dlg.addEventListener('cancel', (e) => { if (!opener) e.preventDefault() })

  dlg.addEventListener('close', () => {
    if (dlg.open) return // the close event comes late: the banner was just reopened as the settings dialog
    if (opener) { opener.focus(); opener = null }
    // settings closed without a decision while the banner was due: the banner comes back (not counted again)
    if (!decidedNow && !decided()) { showPrefs(false); dlg.showModal() }
  })

  const ready = new Promise((resolve) => {
    const done = () => { api = window.Shopify.customerPrivacy; resolve() }
    if (window.Shopify?.customerPrivacy?.currentVisitorConsent) return done()
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], (err) => { if (!err) done() })
  })

  ready.then(() => {
    if (decided()) return toGoogle(current()) // Google's default is "denied" on every page: repeat the stored choice
    // every undecided visitor sees the banner: Shopify's shouldShowBanner() depends on its own region setting and IP
    // geolocation and says false e.g. behind Safari's Private Relay (DE shop, undecided visitor, no banner – 22.10.2026)
    showPrefs(false)
    dlg.showModal()
    dlg.focus({ preventScroll: true }) // announced first; Tab goes on to the link, the categories and the buttons
    countShown()
  })

  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-consent-open]')
    if (!b) return
    e.preventDefault()
    ready.then(() => {
      opener = b
      decidedNow = false
      if (dlg.open) dlg.close()
      dlg.showModal()
      showPrefs(true)
    })
  })
}
})()
